/**
 * Eventos propios del tema
 * ---------------------------------------------------------------------------
 * La Web Pixels API cubre los eventos estándar de comercio (ver producto,
 * añadir a la cesta, comprar…). Lo que NO cubre es la interacción con la
 * interfaz que construimos nosotros: elegir un color, abrir la guía de tallas,
 * filtrar, navegar por el megamenú.
 *
 * Esos eventos se empujan al dataLayer. Desde ahí Google Tag Manager (o el
 * píxel personalizado) puede recogerlos.
 *
 * Importante: aquí NO se envía nada a terceros directamente. Solo se rellena el
 * dataLayer. Quien decide si eso sale de la página es la capa de consentimiento.
 */

window.dataLayer = window.dataLayer || [];

const push = (event, payload = {}) => {
  window.dataLayer.push({ event, ...payload });
};

/* --- Selección de color en la ficha de producto -------------------------- */
document.addEventListener('variant:change', (event) => {
  const { variant, colorValue } = event.detail;
  if (!colorValue) return;

  push('variant_color_selected', {
    color: colorValue,
    variant_id: variant?.id ?? null,
    available: variant?.available ?? null,
  });
});

/* --- Cuántas fotos ve el cliente tras filtrar por color ------------------ */
document.addEventListener('gallery:filtered', (event) => {
  push('gallery_filtered', {
    color: event.detail.colorValue,
    visible_media: event.detail.visibleCount,
  });
});

/* --- Pestañas de la vitrina de la portada -------------------------------- */
document.addEventListener('shelf:tab-changed', (event) => {
  push('shelf_tab_changed', {
    tab_index: event.detail.index,
    tab_label: event.detail.label,
  });
});

/* --- Añadido a la cesta desde la ficha (confirma la apertura del panel) --- */
document.addEventListener('cart:added', (event) => {
  push('cart_drawer_opened', {
    variant_id: event.detail?.item?.variant_id ?? null,
  });
});

/* --- Apertura de paneles laterales --------------------------------------- */
document.addEventListener('drawer:open', (event) => {
  push('drawer_opened', { drawer: event.detail.name });
});

/* --- Decisión de cookies -------------------------------------------------- */
document.addEventListener('consent:updated', (event) => {
  push('consent_updated', event.detail);
});

/* --- Alta en la newsletter ------------------------------------------------ */
document.addEventListener('submit', (event) => {
  const form = event.target.closest('.footer__newsletter-form');
  if (form) push('newsletter_signup', {});
});

/* --- Uso del megamenú ----------------------------------------------------- */
document.addEventListener('click', (event) => {
  const link = event.target.closest('.mega__link, .mega__column-title');
  if (!link) return;

  push('mega_menu_click', {
    link_text: link.textContent.trim(),
    link_url: link.getAttribute('href'),
  });
});

/* --- Filtros de colección ------------------------------------------------- */
document.addEventListener('change', (event) => {
  const control = event.target.closest('[data-facet-auto-submit]');
  if (!control) return;

  push('filter_applied', {
    filter_name: control.getAttribute('name'),
    filter_value: control.value,
  });
});
